import { Emoji, emojis } from "@tiptap/extension-emoji";
import { Image } from "@tiptap/extension-image";
import { FontSize, TextStyle } from "@tiptap/extension-text-style";
import StarterKit from "@tiptap/starter-kit";

import { TemplateTokenNode } from "./TemplateTokenNode";

/**
 * TipTap extensions for the template editor. StarterKit (v3) already bundles bold, italic, strike,
 * underline, inline code, code blocks, headings, blockquote, horizontal rule, link, undo/redo
 * history, and bulleted/ordered lists; `TextStyle` + `FontSize` add font sizing, `Emoji` the emoji
 * picker support, `Image` inline images, and `TemplateTokenNode` the inline token chips. The active
 * formatting *controls* are toggled per mode in the toolbar — the schema itself is mode-independent.
 */
export const createTemplateEditorExtensions = () => [
  // Headings are capped at 1–3 to match the three heading toolbar buttons.
  StarterKit.configure({
    heading: { levels: [1, 2, 3] },
    bulletList: { keepMarks: true },
    orderedList: { keepMarks: true },
    // `text-primary` is a near-black neutral in this palette, so it reads as bold text, not a link;
    // use an explicit blue (with a dark-mode variant) so links are visually distinct while editing.
    link: {
      openOnClick: false,
      HTMLAttributes: { class: "text-blue-600 underline cursor-pointer dark:text-blue-400" },
    },
  }),
  TextStyle,
  FontSize,
  Emoji.configure({ emojis, enableEmoticons: true }),
  Image.configure({ HTMLAttributes: { class: "max-w-full h-auto" } }),
  TemplateTokenNode,
];
